export default "__VITE_ASSET__DwHqlqNw__"